<template>
  <div class="app">
    <div class="bottom">
      <div class="bottom-center">
        <div class="header">
          <div>
            <img class="logo" src="../../assets/images/index/dbdh_logo.png" />
            <div class="content10">
              <h6>关于我们</h6>
              <ul>
                <li>
                  <router-link :to="{ name: 'coreTechnology'}" class="link">核心技术</router-link>
                  <!-- <a>核心技术</a> -->
                </li>
                <li>
                  <router-link :to="{ name: 'SoundDetect'}" class="link">产品系列</router-link>
                  <!-- <a>产品系列</a> -->
                </li>
                <li>
                  <router-link :to="{ name: 'experienceCenter'}" class="link">产品体验</router-link>
                  <!-- <a>产品体验</a> -->
                </li>
              </ul>
            </div>

            <div class="content10">
              <h6>加入我们</h6>
              <div class="concat">
                <div>
                  <router-link
                    v-if="isIE"
                    style
                    :to="{ name: 'joinus'}"
                    class="link duan whie"
                  >职 位 详 情</router-link>
                  <router-link v-if="!isIE" :to="{ name: 'joinus'}" class="link duan wh">职位详情</router-link>
                </div>
                <div>
                  <span v-if="isIE" class="duan whie">邮 箱</span>
                  <span v-if="!isIE" class="duan wh">邮 箱</span>
                  <p class="duanvalue">：hr@dasoundgen.com</p>
                </div>
              </div>
            </div>

            <div class="content10">
              <h6>联系我们</h6>
              <div class="concat" v-if="isIE">
                <div v-for="(item, index) in concatmeth" :key="index">
                  <p class="duan whie">{{item['label']}}</p>
                  <p class="duanvalue">{{item['value']}}</p>
                </div>
              </div>
              <div class="concat" v-if="!isIE">
                <div v-for="(item, index) in concat" :key="index">
                  <p class="duan wh">{{item['label']}}</p>
                  <p class="duanvalue">{{item['value']}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <p class="copyright">Copyright@武汉大晟极科技有限公司</p>
        <p class="baben" @click="gotobanben">鄂ICP备19006647号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      concatmeth: [
        { 'label': '联 系 电 话', 'value': '：027-81736698', 'ie': true },
        { 'label': '地 址', 'value': '：中国•光谷•武大科技园航域二区B3栋7楼', 'ie': true },
        { 'label': '邮 箱', 'value': '：market@dasoundgen.com', 'ie': true }
      ],
      concat: [
        { 'label': '联系电话', 'value': '：027-81736698', 'ie': false },
        { 'label': '地址', 'value': '：中国•光谷•武大科技园航域二区B3栋7楼', 'ie': false },
        { 'label': '邮箱', 'value': '：market@dasoundgen.com', 'ie': false }
      ],
      isIE: false
    }
  },
  // 
  methods: {
    gotobanben () {
      const url = 'http://beian.miit.gov.cn'
      window.open(url)
    },
    getWeb () {
      let userAgent = navigator.userAgent
      if ((userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0')) || ((userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1))) {
        this.wavUrl = this.theUrl
        this.isIE = true
      } else {
        this.isIE = false
      }
    }
  },
  mounted () {
    this.getWeb()
  }
}
</script>

<style scoped>
.bottom {
  width: 100%;
  height: 100%;
  font-weight: 400;
  background: rgba(44, 44, 44, 1);
  min-width: 1040px;
}
.bottom-center {
  background: rgba(44, 44, 44, 1);
  color: rgba(153, 153, 153, 1);
  height: 237px;
}
.header {
  width: 1080px;
  margin: 0 auto;
  padding-top: 33px;
}

.content10 {
  float: left;
  width: 250px;
  transition: all 0.3s;
}
.concat {
  margin-top: 18px;
}
.concat div {
  /* text-align: left; */
  float: left;
}
.whie {
  width: 70px;
}
.wh {
  width: 60px;
}
.duan {
  text-align: justify;
  text-justify: distribute-all-lines; /*ie6-8*/
  -webkit-text-align: justify;
  text-align-last: justify; /* ie9*/
  -moz-text-align-last: justify; /*ff*/
  -webkit-text-align-last: justify; /*chrome 20+*/
  line-height: 13px;
  float: left;
}
.duan:after {
  content: ".";
  width: 100%;
  display: inline-block;
  overflow: hidden;
  height: 0;
}
.link {
  margin-bottom: 9px;
}
.duanvalue {
  width: 370px;
  text-align: left;
  margin-top: -5px;
}
.logo {
  float: left;
  margin-bottom: 72px;
  padding-right: 10%;
  margin-top: 67px;
  /* padding-right: 186px;
  padding-left: 286px; */
}
h6 {
  font-weight: Medium;
  line-height: 48px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
li {
  text-align: left;
  line-height: 7px;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(154, 154, 154, 1);
}
.foot {
  background: rgba(51, 51, 51, 1);
  height: 99px;
  color: rgba(153, 153, 153, 1);
}
.foot .copyright {
  padding-top: 26.5px;
  line-height: 20px;
  font-size: 18px;
  margin-bottom: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.foot:last-child {
  font-size: 18px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
a {
  width: 181px;
  height: 16px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(154, 154, 154, 1);
}
/* a:hover {
  c
} */
.link:hover {
  color: white;
}
.baben {
  display: inline;
}
.baben:hover {
  color: #f63c0a;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue